import React from "react";
import { getLink } from "../../utils/helpers";

const CalcularPrestacionesForm = ({ toggle, filtrosQuery }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const queryParams = new URLSearchParams(formData).toString();

        const url = getLink(`/imprimir/calculo-prestaciones${filtrosQuery}&${queryParams}`);
        window.open(url, "_blank");
        toggle();
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className='popup__header'>Calcular Prestaciones</div>

            <div className='popup__body'>
                <div className="form-group">
                    <label htmlFor="termino">Fecha de término</label>
                    <input type="date" name="termino" id="termino" className="form-control" required />
                </div>

                <div className="row">

                    <div className="form-group col-12 col-md-6">
                        <label htmlFor="preaviso">¿Han sido pre-avisado?</label>
                        <label className='switch switch-3d switch-success mb-0'>
                            <input
                                type='checkbox'
                                className='switch-input'
                                id='preaviso'
                                name='preaviso'
                                value='si'
                                defaultChecked={true}
                            />
                            <span className='switch-label' />
                            <span className='switch-handle' />
                        </label>
                    </div>

                    <div className="form-group col-12 col-md-6">
                        <label htmlFor="cesantia">¿Desea incluir cesantía?</label>
                        <label className='switch switch-3d switch-success mb-0'>
                            <input
                                type='checkbox'
                                className='switch-input'
                                id='cesantia'
                                name='cesantia'
                                value='si'
                                defaultChecked={true}
                            />
                            <span className='switch-label' />
                            <span className='switch-handle' />
                        </label>
                    </div>

                    <div className="form-group col-12 col-md-6">
                        <label htmlFor="vacaciones">¿Han tomado las vacaciones correspondientes al último año?</label>
                        <label className='switch switch-3d switch-success mb-0'>    
                            <input
                                type='checkbox'
                                className='switch-input'
                                id='vacaciones'
                                name='vacaciones'
                                value='si'
                                defaultChecked={true}
                            />
                            <span className='switch-label' />
                            <span className='switch-handle' />
                        </label>
                    </div>

                    <div className="form-group col-12 col-md-6">
                        <label htmlFor="navidad">¿Incluir salario de navidad?</label>
                        <label className='switch switch-3d switch-success mb-0'>
                            <input
                                type='checkbox'
                                className='switch-input'
                                id='navidad'
                                name='navidad'
                                value='si'
                                defaultChecked={true}
                            />
                            <span className='switch-label' />
                            <span className='switch-handle' />
                        </label>
                    </div>
                </div>
            </div>

            <div className='popup__footer d-flex'>
                <button type="button" onClick={toggle} className="btn btn-plain mr-auto">Cancelar</button>
                <button type="submit" className="btn btn-primary">Calcular Prestaciones</button>
            </div>
        </form>
    );
};

export default CalcularPrestacionesForm;